__turbopack_context__.v({
  "container": "TransformingTalentAcrossIndustries-module-scss-module__LAmRMq__container",
  "content": "TransformingTalentAcrossIndustries-module-scss-module__LAmRMq__content",
  "ctaButton": "TransformingTalentAcrossIndustries-module-scss-module__LAmRMq__ctaButton",
  "flipCard": "TransformingTalentAcrossIndustries-module-scss-module__LAmRMq__flipCard",
  "flipCardFront": "TransformingTalentAcrossIndustries-module-scss-module__LAmRMq__flipCardFront",
  "flipCardInner": "TransformingTalentAcrossIndustries-module-scss-module__LAmRMq__flipCardInner",
  "gridContainer": "TransformingTalentAcrossIndustries-module-scss-module__LAmRMq__gridContainer",
  "heading": "TransformingTalentAcrossIndustries-module-scss-module__LAmRMq__heading",
  "overlay": "TransformingTalentAcrossIndustries-module-scss-module__LAmRMq__overlay",
  "perGrid": "TransformingTalentAcrossIndustries-module-scss-module__LAmRMq__perGrid",
  "subtext": "TransformingTalentAcrossIndustries-module-scss-module__LAmRMq__subtext",
  "testimonialsSection": "TransformingTalentAcrossIndustries-module-scss-module__LAmRMq__testimonialsSection",
});
